const searchFormValue = {
    search: null,
    locale: null,
};

const localeOptions = [
    { text: '전체', value: null },
    { text: '한국어', value: 'ko' },
    { text: '영어', value: 'en' },
    { text: '중국어', value: 'ca' },
];

const columns = [
    {
        key: 'index',
        label: '번호',
        thStyle: {
            width: '60px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'key',
        label: '문자열 키',
        thStyle: {
            width: '150px'
        },
        thClass: ['mb-0','th-left'],
        tdClass: ['td-left', 'text-truncate'],
    },
    {
        key: 'ko',
        label: '한국어',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0','th-left'],
        tdClass: ['td-left', 'text-truncate'],
    },
    {
        key: 'en',
        label: '영어',
        thStyle: {
            width: '150px'
        },
        thClass: ['mb-0','th-left'],
        tdClass: ['td-left', 'text-truncate'],
    },
    {
        key: 'ca',
        label: '중국어',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0','th-left'],
        tdClass: ['td-left', 'text-truncate'],
    },
    {
        key: 'detail',
        label: '상세',
        thStyle: {
            width: '60px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'updated_at',
        label: '수정일시',
        thStyle: {
            width: '160px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
];

// 목록 탭(ManageLocaleString) 표 — DS 표 규칙. 언어 세 칸은 폭을 적지 않아 남는 폭을 똑같이 나눠 갖는다(표 최소 폭은 ManageLocaleString.vue).
// 위 columns 는 검색 창(LocaleStringSearchModal)이 그대로 쓴다
const listColumns = [
    {key: 'index', label: 'No.', thClass: ['ds-cell-no'], tdClass: ['ds-cell-no'], thStyle: {width: '64px'}},
    {key: 'key', label: '문자열 키', thStyle: {width: '220px'}},
    {key: 'ko', label: '한국어'},
    {key: 'en', label: '영어'},
    {key: 'ca', label: '중국어'},
    {key: 'updated_at', label: '수정일시', tdClass: ['ds-cell-nowrap'], thStyle: {width: '168px'}},
    {key: 'detail', label: '상세', tdClass: ['text-right'], thStyle: {width: '64px'}},
];

export { searchFormValue, columns, listColumns, localeOptions};
